import { render, staticRenderFns } from "./detailsSupplierSupplyList.vue?vue&type=template&id=efd3b552&scoped=true"
import script from "./detailsSupplierSupplyList.vue?vue&type=script&lang=js"
export * from "./detailsSupplierSupplyList.vue?vue&type=script&lang=js"
import style0 from "./detailsSupplierSupplyList.vue?vue&type=style&index=0&id=efd3b552&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efd3b552",
  null
  
)

export default component.exports